import { useEffect } from 'react';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';

export const useEscToCloseModalFromIframe = () => {
	const isHTMLInput = (e: HTMLElement) =>
		['INPUT', 'TEXTAREA', 'OPTION', 'SELECT'].includes(e.nodeName);

	const messageEventHandler = (e: MessageEvent) => {
		try {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			const eventWindow = e.target as Window;
			if (eventWindow.frames) {
				const frame = eventWindow.frames[0];

				if (frame != null && e.data.type === 'init' && e.origin === window.location.origin) {
					const parsedName = JSON.parse(frame.name || '{}');
					if (parsedName && parsedName.extension_id?.startsWith('embedded-confluence-iframe')) {
						const frameEventHandler = (frameEvent: KeyboardEvent) => {
							// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
							const isInput = isHTMLInput(frameEvent.target as HTMLElement);
							if (!isInput && frameEvent.key === 'Escape') {
								eventWindow.document.dispatchEvent(
									new KeyboardEvent('keydown', {
										key: 'Escape',
									}),
								);
								frame.removeEventListener('keydown', frameEventHandler);
							}
						};

						frame.addEventListener('keydown', frameEventHandler);
					}
				}
			}
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'escToCloseModalFromIframe',
					packageName: 'jiraBusinessConfluencePages',
					teamName: 'jira-warepil',
				},
				sendToPrivacyUnsafeSplunk: true,
				error,
			});
		}
	};

	useEffect(() => {
		window.addEventListener('message', messageEventHandler);

		return () => {
			window.removeEventListener('message', messageEventHandler);
		};
	});
};
